import { DataService } from '../../../shared/dataservice.service';
import { Component, OnInit, Input } from '@angular/core';
import { SalesOrder, SubSalesOrder, SOStatus, SSOStatus, monthFilter, PmTechnicalIP,  UiFunctionalKPI } from '../../../shared/misc-classes';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { KPIChartService } from '../../../shared/kpi-charts-service';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-engg-draw-kpi',
  templateUrl: './engg-draw-kpi.component.html',
  styleUrls: ['./engg-draw-kpi.component.css']
})
export class EnggDrawKpiComponent implements OnInit {

  @Input() pmTechSSO: PmTechnicalIP;
  soObj: SalesOrder;
  _soObjListKpi2: Array<SalesOrder>;

  filteredSOCount: number = 0;
  filteredSSOCount: number = 0;
  isDataViewUpdated4: boolean = false;
  isLoading: boolean = false;
  EnggDrawKpi: Array<UiFunctionalKPI> = [];


  isManfMonthFilterSelectedKpi1: boolean = false;
  manfMonthFilterKpi1: monthFilter;

  Highcharts = Highcharts;

  totalDataSLD: any;
  totalDataKpiChartOptionsSLD: Highcharts.Options;
  panelWiseDataSLD: any;
  panelWiseKpiChartOptionsSLD: Highcharts.Options;

  totalDataGA: any;
  totalDataKpiChartOptionsGA: Highcharts.Options;
  panelWiseDataGA: any;
  panelWiseKpiChartOptionsGA: Highcharts.Options;

  totalDataSCHEME: any;
  totalDataKpiChartOptionsSCHEME: Highcharts.Options;
  panelWiseDataSCHEME: any;
  panelWiseKpiChartOptionsSCHEME: Highcharts.Options;

  constructor(public _dataService: DataService, public dialog: MatDialog,
    private _kpiCharServ: KPIChartService) { }

  ngOnInit() {
    try {
      this.loadSettingsFromCookies();
    } catch (e) {
      console.log(e);
    }

    this.loadData();
  }
  saveSettingsToCookies() {
    this._dataService.setCookie('s-manfmonth-sel-kpi-2', this.isManfMonthFilterSelectedKpi1 ? "1" : "0");
    if (this.isManfMonthFilterSelectedKpi1) {
      this._dataService.setCookie('s-manfmonth-val-kpi-2', this.manfMonthFilterKpi1.getCookieStr());
    }
  }
  loadSettingsFromCookies() {


    let _tmpManfMonthSel: string = this._dataService.getCookie('s-manfmonth-sel-kpi-2');
    if (_tmpManfMonthSel) {
      this.isManfMonthFilterSelectedKpi1 = (_tmpManfMonthSel == "1");

      let _tmpManfMonthVal: string = this._dataService.getCookie('s-manfmonth-val-kpi-2');
      if (_tmpManfMonthVal) {
        this.manfMonthFilterKpi1 = monthFilter.getObjFromCookieStr(_tmpManfMonthVal);
      }
    }


    let _currDate: Date = new Date();
    if (this.manfMonthFilterKpi1 == null) {
      this.manfMonthFilterKpi1 = new monthFilter(_currDate.getMonth() + 1, _currDate.getFullYear(),
        _currDate.getMonth() + 1, _currDate.getFullYear());
    }

  }
  loadData() {
    this.isLoading = true;
    this._dataService.getDataDefinitions().subscribe(res => {
      this._dataService.getAllSalesOrder(1).subscribe((_soObjAr: Array<SalesOrder>) => {
        this._soObjListKpi2 = _soObjAr.filter((_tmpSO2: SalesOrder) => {
          //test the filter.
          // if(_tmpSO2.projectStatus == SOStatus.Dispatched || _tmpSO2.projectStatus == SOStatus.Archived)
          if (_tmpSO2.projectStatus == SOStatus.Dispatched) {
            return false;
          }
          return true;
        });
        this.filterRows();
      });
    });
  }

  getClassName(_temp: number): string {
    if (_temp < 6) {
      return "bg-grey";
    } else if (_temp >= 6 && _temp < 10) {
      return "bg-yellow";
    } else if (_temp > 10) {
      return "bg-green";
    }
  }



  reloadData(): void {
    this.isLoading = true;
    this.loadData();
  }
  clearFilters(): void {

    this.isManfMonthFilterSelectedKpi1 = false;
    this.isLoading = true;
    this.loadData();

    setTimeout(() => {
      this.saveSettingsToCookies();
    }, 10);
  }



  filterRows(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic2();
      this.isLoading = false;
    }, 5);
    this.saveSettingsToCookies();
  }


  private displaySOwithNoSSO() {
    if (this.isManfMonthFilterSelectedKpi1 == true

    ) {
      return false;
    }

    return true;
  }


  filterRowsLogic2() {
    let _tmpSOCounter: number = 0;
    let _tmpSSOCounter: number = 0;
    let _tmpEnggDrawKpi: Array<UiFunctionalKPI> = [];

    let _totalQtySLD: number = 0;
    let _delayQtySLD: number = 0;
    let _onTimeQtySLD: number = 0;
    let _delayQtySLDZS1: number = 0;
    let _onTimeQtySLDZS1: number = 0;
    let _delayQtySLDZS1DBB: number = 0;
    let _onTimeQtySLDZS1DBB: number = 0;
    let _delayQtySLDZS2: number = 0;
    let _onTimeQtySLDZS2: number = 0;
    let _delayQtySLDZS9: number = 0;
    let _onTimeQtySLDZS9: number = 0;
    let _delayQtySLDZN1: number = 0;
    let _onTimeQtySLDZN1: number = 0;

    let _totalQtyGA: number = 0;
    let _delayQtyGA: number = 0;
    let _onTimeQtyGA: number = 0;
    let _delayQtyGAZS1: number = 0;
    let _onTimeQtyGAZS1: number = 0;
    let _delayQtyGAZS1DBB: number = 0;
    let _onTimeQtyGAZS1DBB: number = 0;
    let _delayQtyGAZS2: number = 0;
    let _onTimeQtyGAZS2: number = 0;
    let _delayQtyGAZS9: number = 0;
    let _onTimeQtyGAZS9: number = 0;
    let _delayQtyGAZN1: number = 0;
    let _onTimeQtyGAZN1: number = 0;

    let _totalQtySCHEME: number = 0;
    let _delayQtySCHEME: number = 0;
    let _onTimeQtySCHEME: number = 0;
    let _delayQtySCHEMEZS1: number = 0;
    let _onTimeQtySCHEMEZS1: number = 0;
    let _delayQtySCHEMEZS1DBB: number = 0;
    let _onTimeQtySCHEMEZS1DBB: number = 0;
    let _delayQtySCHEMEZS2: number = 0;
    let _onTimeQtySCHEMEZS2: number = 0;
    let _delayQtySCHEMEZS9: number = 0;
    let _onTimeQtySCHEMEZS9: number = 0;
    let _delayQtySCHEMEZN1: number = 0;
    let _onTimeQtySCHEMEZN1: number = 0;

    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

    let _showSOWithNoSSO: boolean = this.displaySOwithNoSSO();

    for (var i = 0; i < this._soObjListKpi2.length; i++) {
      let _tmpSO: SalesOrder = this._soObjListKpi2[i];

      let _isSOPassedFilter: boolean = true;
      if (_isSOPassedFilter == true) {
        let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrders(_tmpSO.subSalesOrder);

        if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {

          let _tmpSSOobj: UiFunctionalKPI;

          _tmpSOCounter++;

          _filteredSSO.forEach((_tmpSSO: SubSalesOrder) => {

            

            // Check for SLD planned and Actual Dates      

            if (_tmpSSO.pmTechSubSalesOrder.plannedSldSubmissionDate != null && _tmpSSO.enggDrawIP.initialSLDSubmissionDateActual != null) {


              // Total Panel Qty  

            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtySLD += temp;
                  
                }
              }
            });

            let isRevisedSLD = _tmpSSO.pmTechSubSalesOrder.plannedSldSubmissionDateIsRevised;

              let _sldPlanned = _tmpSSO.pmTechSubSalesOrder.plannedSldSubmissionDate.getTime();
              let _sldActual = _tmpSSO.enggDrawIP.initialSLDSubmissionDateActual.getTime();
              let _sldDiff_time = _sldPlanned - _sldActual;
              let _sldDiff = _sldDiff_time / (1000 * 3600 * 24);

              // SLD Delay
              if (_sldDiff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtySLD += temp;
                    }
                  }
                });
                let _individualDelayQtySLD = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtySLDZS1 += temp;
                          _individualDelayQtySLD += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtySLDZS1DBB += temp;
                          _individualDelayQtySLD += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtySLDZS2 += temp;
                          _individualDelayQtySLD += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtySLDZN1 += temp;
                          _individualDelayQtySLD += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtySLDZS9 += temp;
                          _individualDelayQtySLD += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp = isRevisedSLD == true? null: _tmpSSO.pmTechSubSalesOrder.plannedSldSubmissionDate;
                let _revisedTmp = isRevisedSLD == false? null: _tmpSSO.pmTechSubSalesOrder.plannedSldSubmissionDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'SLD', _tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtySLD, _plannedTmp , _revisedTmp, null, _tmpSSO.enggDrawIP.initialSLDSubmissionDateActual, _sldDiff, _tmpSSO.enggDrawIP.initialSLDSubmissionActualDateToken.addNotes)

                _tmpEnggDrawKpi.push(_tmpSSOobj);
              }
              // SLD on Time
              if (_sldDiff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtySLD += temp;
                    }
                  }
                });

                let _individualOnTimeQtySLD = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtySLDZS1 += temp;
                          _individualOnTimeQtySLD += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtySLDZS1DBB += temp;
                          _individualOnTimeQtySLD += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtySLDZS2 += temp;
                          _individualOnTimeQtySLD += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtySLDZN1 += temp;
                          _individualOnTimeQtySLD += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtySLDZS9 += temp;
                          _individualOnTimeQtySLD += temp;
                        }
                      }
                    });
                    break;
                }
                let _plannedTmp = isRevisedSLD == true? null: _tmpSSO.pmTechSubSalesOrder.plannedSldSubmissionDate;
                let _revisedTmp = isRevisedSLD == false? null: _tmpSSO.pmTechSubSalesOrder.plannedSldSubmissionDate;
                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'SLD', _tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtySLD, _plannedTmp , _revisedTmp, null, _tmpSSO.enggDrawIP.initialSLDSubmissionDateActual, _sldDiff, _tmpSSO.enggDrawIP.initialSLDSubmissionActualDateToken.addNotes)

                _tmpEnggDrawKpi.push(_tmpSSOobj);
              }


            }



            ////////////////////////// Check for GA planned and Actual Dates      

            if (_tmpSSO.pmTechSubSalesOrder.plannedGaDrawingSubmissionDate != null && _tmpSSO.enggDrawIP.initialGAFDSubmissionDateActual != null) {

              // Total Panel Qty  

            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtyGA += temp;
                  
                }
              }
            });

              let isRevisedGA = _tmpSSO.pmTechSubSalesOrder.plannedGaDrawingSubmissionDateIsRevised;

              let _gaPlanned = _tmpSSO.pmTechSubSalesOrder.plannedGaDrawingSubmissionDate.getTime();
              let _gaActual = _tmpSSO.enggDrawIP.initialGAFDSubmissionDateActual.getTime();
              let _gaDiff_time = _gaPlanned - _gaActual;
              let _gaDiff = _gaDiff_time / (1000 * 3600 * 24);

              // GA Delay
              if (_gaDiff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtyGA += temp;
                    }
                  }
                });
                let _individualDelayQtyGA = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyGAZS1 += temp;
                          _individualDelayQtyGA += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyGAZS1DBB += temp;
                          _individualDelayQtyGA += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyGAZS2 += temp;
                          _individualDelayQtyGA += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyGAZN1 += temp;
                          _individualDelayQtyGA += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyGAZS9 += temp;
                          _individualDelayQtyGA += temp;
                        }
                      }
                    });
                    break;
                }
                let _plannedTmp = isRevisedGA == true? null: _tmpSSO.pmTechSubSalesOrder.plannedGaDrawingSubmissionDate;
                let _revisedTmp = isRevisedGA == false? null:_tmpSSO.pmTechSubSalesOrder.plannedGaDrawingSubmissionDate;
               
                _tmpSSOobj = new UiFunctionalKPI( _tmpSSO.planningIP.plannedManufacturingMonth, 'GA', _tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtyGA, _plannedTmp, _revisedTmp , null, _tmpSSO.enggDrawIP.initialGAFDSubmissionDateActual, _gaDiff, _tmpSSO.enggDrawIP.initialGAFDSubmissionActualDateToken.addNotes)

                _tmpEnggDrawKpi.push(_tmpSSOobj);
              }
              // GA on Time
              if (_gaDiff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtyGA += temp;
                    }
                  }
                });

                let _individualOnTimeQtyGA = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyGAZS1 += temp;
                          _individualOnTimeQtyGA += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyGAZS1DBB += temp;
                          _individualOnTimeQtyGA += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyGAZS2 += temp;
                          _individualOnTimeQtyGA += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyGAZN1 += temp;
                          _individualOnTimeQtyGA += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyGAZS9 += temp;
                          _individualOnTimeQtyGA += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp = isRevisedGA == true? null: _tmpSSO.pmTechSubSalesOrder.plannedGaDrawingSubmissionDate;
                let _revisedTmp = isRevisedGA == false? null:_tmpSSO.pmTechSubSalesOrder.plannedGaDrawingSubmissionDate

                _tmpSSOobj = new UiFunctionalKPI( _tmpSSO.planningIP.plannedManufacturingMonth, 'GA', _tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtyGA, _plannedTmp, _revisedTmp , null, _tmpSSO.enggDrawIP.initialGAFDSubmissionDateActual, _gaDiff, _tmpSSO.enggDrawIP.initialGAFDSubmissionActualDateToken.addNotes)

                _tmpEnggDrawKpi.push(_tmpSSOobj);
              }


            }

            ////////////////////////// Check for SCHEME planned and Actual Dates      

            if (_tmpSSO.pmTechSubSalesOrder.plannedSchematicDrawingDate != null && _tmpSSO.enggDrawIP.initialSchematicDBOMSubmissionDateActual != null) {

              // Total Panel Qty  

            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtySCHEME += temp;
                }
              }
            });

              let isRevisedSCHEME = _tmpSSO.pmTechSubSalesOrder.plannedSchematicDrawingDateIsRevised;

              let _schemePlanned = _tmpSSO.pmTechSubSalesOrder.plannedSchematicDrawingDate.getTime();
              let _schemeActual = _tmpSSO.enggDrawIP.initialSchematicDBOMSubmissionDateActual.getTime();
              let _schemeDiff_time = _schemePlanned - _schemeActual;
              let _schemeDiff = _schemeDiff_time / (1000 * 3600 * 24);

              // SCHEME Delay
              if (_schemeDiff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtySCHEME += temp;
                    }
                  }
                });

                let _individualDelayQtyScheme = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtySCHEMEZS1 += temp;
                          _individualDelayQtyScheme += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtySCHEMEZS1DBB += temp;
                          _individualDelayQtyScheme += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtySCHEMEZS2 += temp;
                          _individualDelayQtyScheme += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtySCHEMEZN1 += temp;
                          _individualDelayQtyScheme += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtySCHEMEZS9 += temp;
                          _individualDelayQtyScheme += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp = isRevisedSCHEME == true? null: _tmpSSO.pmTechSubSalesOrder.plannedSchematicDrawingDate;
                let _revisedTmp = isRevisedSCHEME == false? null:_tmpSSO.pmTechSubSalesOrder.plannedSchematicDrawingDate;

                _tmpSSOobj = new UiFunctionalKPI( _tmpSSO.planningIP.plannedManufacturingMonth, 'SCHEME', _tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtyScheme, _plannedTmp, _revisedTmp, null, _tmpSSO.enggDrawIP.initialSchematicDBOMSubmissionDateActual, _schemeDiff, _tmpSSO.enggDrawIP.initialSchematicDBOMSubmissionActualDateToken.addNotes)

                _tmpEnggDrawKpi.push(_tmpSSOobj);
              }
              // GA on Time
              if (_schemeDiff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtySCHEME += temp;
                    }
                  }
                });

                let _individualOnTimeQtyScheme = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtySCHEMEZS1 += temp;
                          _individualOnTimeQtyScheme += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtySCHEMEZS1DBB += temp;
                          _individualOnTimeQtyScheme += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtySCHEMEZS2 += temp;
                          _individualOnTimeQtyScheme += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtySCHEMEZN1 += temp;
                          _individualOnTimeQtyScheme += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtySCHEMEZS9 += temp;
                          _individualOnTimeQtyScheme += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp = isRevisedSCHEME == true? null: _tmpSSO.pmTechSubSalesOrder.plannedSchematicDrawingDate;
                let _revisedTmp = isRevisedSCHEME == false? null:_tmpSSO.pmTechSubSalesOrder.plannedSchematicDrawingDate;

                _tmpSSOobj = new UiFunctionalKPI( _tmpSSO.planningIP.plannedManufacturingMonth, 'SCHEME', _tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtyScheme, _plannedTmp, _revisedTmp, null, _tmpSSO.enggDrawIP.initialSchematicDBOMSubmissionDateActual, _schemeDiff, _tmpSSO.enggDrawIP.initialSchematicDBOMSubmissionActualDateToken.addNotes)

                _tmpEnggDrawKpi.push(_tmpSSOobj);
              }


            }

            

          });

        }


      }

    }

    if (_totalQtySLD != 0 || _onTimeQtySLD != 0 || _delayQtySLD != 0) {
      this.totalDataSLD = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtySLD,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtySLD,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtySLD,
        }]
      }

      ];
    }
    else { this.totalDataSLD = null; }

    this.totalDataKpiChartOptionsSLD = this._kpiCharServ.getTotalDataChartOptions(this.totalDataSLD);

    if (_onTimeQtySLDZN1 != 0 || _onTimeQtySLDZS9 != 0 || _onTimeQtySLDZS1 != 0 || _onTimeQtySLDZS1DBB != 0 || _onTimeQtySLDZS2 != 0
      || _delayQtySLDZN1 != 0 || _delayQtySLDZS9 != 0 || _delayQtySLDZS1 != 0 || _delayQtySLDZS1DBB != 0 || _delayQtySLDZS2 != 0) {

      this.panelWiseDataSLD = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtySLDZN1, _onTimeQtySLDZS9, _onTimeQtySLDZS1, _onTimeQtySLDZS1DBB, _onTimeQtySLDZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtySLDZN1, _delayQtySLDZS9, _delayQtySLDZS1, _delayQtySLDZS1DBB, _delayQtySLDZS2],
      }

      ];
    }
    else { this.panelWiseDataSLD = null; }

    this.panelWiseKpiChartOptionsSLD = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataSLD);

    ////////////////////

    if (_totalQtyGA != 0 || _onTimeQtyGA != 0 || _delayQtyGA != 0) {
      this.totalDataGA = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtyGA,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtyGA,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtyGA,
        }]
      }

      ];
    }
    else { this.totalDataGA = null; }

    this.totalDataKpiChartOptionsGA = this._kpiCharServ.getTotalDataChartOptions(this.totalDataGA);

    if (_onTimeQtyGAZN1 != 0 || _onTimeQtyGAZS9 != 0 || _onTimeQtyGAZS1 != 0 || _onTimeQtyGAZS1DBB != 0 || _onTimeQtyGAZS2 != 0
      || _delayQtyGAZN1 != 0 || _delayQtyGAZS9 != 0 || _delayQtyGAZS1 != 0 || _delayQtyGAZS1DBB != 0 || _delayQtyGAZS2 != 0) {

      this.panelWiseDataGA = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtyGAZN1, _onTimeQtyGAZS9, _onTimeQtyGAZS1, _onTimeQtyGAZS1DBB, _onTimeQtyGAZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtyGAZN1, _delayQtyGAZS9, _delayQtyGAZS1, _delayQtyGAZS1DBB, _delayQtyGAZS2],
      }

      ];
    }
    else { this.panelWiseDataGA = null; }

    this.panelWiseKpiChartOptionsGA = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataGA);


    ////////////////////

    if (_totalQtySCHEME != 0 || _onTimeQtySCHEME != 0 || _delayQtySCHEME != 0) {
      this.totalDataSCHEME = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtySCHEME,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtySCHEME,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtySCHEME,
        }]
      }

      ];
    }
    else { this.totalDataSCHEME = null; }

    this.totalDataKpiChartOptionsSCHEME = this._kpiCharServ.getTotalDataChartOptions(this.totalDataSCHEME);

    if (_onTimeQtySCHEMEZN1 != 0 || _onTimeQtySCHEMEZS9 != 0 || _onTimeQtySCHEMEZS1 != 0 || _onTimeQtySCHEMEZS1DBB != 0 || _onTimeQtySCHEMEZS2 != 0
      || _delayQtySCHEMEZN1 != 0 || _delayQtySCHEMEZS9 != 0 || _delayQtySCHEMEZS1 != 0 || _delayQtySCHEMEZS1DBB != 0 || _delayQtySCHEMEZS2 != 0) {

      this.panelWiseDataSCHEME = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtySCHEMEZN1, _onTimeQtySCHEMEZS9, _onTimeQtySCHEMEZS1, _onTimeQtySCHEMEZS1DBB, _onTimeQtySCHEMEZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtySCHEMEZN1, _delayQtySCHEMEZS9, _delayQtySCHEMEZS1, _delayQtySCHEMEZS1DBB, _delayQtySCHEMEZS2],
      }

      ];
    }
    else { this.panelWiseDataSCHEME = null; }

    this.panelWiseKpiChartOptionsSCHEME = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataSCHEME);




    this.filteredSOCount = _tmpSOCounter;
    this.filteredSSOCount = _tmpSSOCounter;
    this.EnggDrawKpi = _tmpEnggDrawKpi;


    this.isDataViewUpdated4 = true;
    setTimeout(() => {
      this.isDataViewUpdated4 = false;
    }, 1000);
  }


  getManfMonthLabel(): string {
    if (this.isManfMonthFilterSelectedKpi1 == true) {
      return "Manufacturing Month : ";
    }
    else {
      return "Enable Manufacturing Month Filter";
    }
  }

  getManfFromMonthName(): string {
    if (this.manfMonthFilterKpi1) {
      return this.manfMonthFilterKpi1.fromMonthName;
    }
    return '';
  }
  getManfToMonthName(): string {
    if (this.manfMonthFilterKpi1) {
      return this.manfMonthFilterKpi1.toMonthName;
    }
    return '';
  }

  manfPrevFromMonth() {
    this.manfMonthFilterKpi1.prevFromMonth();
    this.filterRows();
  }
  manfNextFromMonth() {
    this.manfMonthFilterKpi1.nextFromMonth();
    this.filterRows();
  }
  manfPrevToMonth() {
    this.manfMonthFilterKpi1.prevToMonth();
    this.filterRows();
  }
  manfNextToMonth() {
    this.manfMonthFilterKpi1.nextToMonth();
    this.filterRows();
  }

  private getFilteredSubOrders(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      //check for failure cases
      //dont show if sub order is dispatched
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true) return false;

      //check if mfg month 
      if (this.isManfMonthFilterPassed(_sso.manufacturingMonth) == false) return false;
      return true;
    });
  }


  private isManfMonthFilterPassed(_manfMonth: Date) {
    if (this.isManfMonthFilterSelectedKpi1 == true && this.manfMonthFilterKpi1 != null) {
      if (this.manfMonthFilterKpi1.isWithInFilterScope(_manfMonth) == false) {
        return false;
      }
    }
    return true;
  }

}
